import { render, staticRenderFns } from "./NbShipmentInformation.vue?vue&type=template&id=05d66ba0&"
import script from "./NbShipmentInformation.vue?vue&type=script&lang=js&"
export * from "./NbShipmentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports